module.exports = __webpack_public_path__ + "img/leonieandco-review-grid.e2e9a8e8.webp";